module.exports = __webpack_public_path__ + "static/media/snapshots-img-1.e2bf1b72.jpg";